<template>
  <div id="app">
    <v-app>
      <!-- can put margin here if want to adjust margin class='mt-1' -->
      <successToast ref="successToast" /> 
      <errorToast ref="errorToast"/> 
      <v-main>
        <router-view />
        <v-footer class="footer-background-color" fixed bottom>
          <v-col class="pa-0 text-center grey--text" cols="12">
            © Copyright 2024 Powered by : www.csiworkdesk.com
          </v-col>
        </v-footer>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import successToast from '@/components/Snackbars/successSnackbar.vue'
import errorToast from '@/components/Snackbars/errorSnackbar.vue'
export default {
  name: 'App',
  data() {
    return {
      isLoggedIn: false,
    }
  },
  components: {
    successToast,
    errorToast
  },
  mounted() {
    this.$nextTick(()=>{ this.$root.successToast = this.$refs.successToast });
    this.$nextTick(()=>{ this.$root.errorToast = this.$refs.errorToast });
  },
}
</script>

<style scoped>
.footer-background-color {
  background-color: #e0e0e0;
}
</style>